export default __webpack_public_path__ + "alberta-doctor.d6a74dc7435df171fab6.svg";